import { Grid2, Typography } from "@mui/material";
import {
  paymentDetailVeteransAffairsEnumMap,
  paymentMethodEnumMap,
  paymentServiceEnumMap,
  paymentTermsAndAgreement,
} from "../enum/formEnum";
import ExpandableTypography from "./ExpandableTypography";

const PaymentDetail = ({ formData }) => {
  const paymentDetailsLabels = {
    baseRate: "Base Rate (Per Hour)",
    veteransAffairs:
      "Do you plan to use Veterans Affairs (VA) benefits to pay for or support your care?",
    serviceType: "Service Type",
    signatureInfo: "Signature",
    paymentMethod: "Payment Method",
  };

  const bankDetailsLabels = {
    bankName: "Depository Bank Name",
    accountNumber: "Account Number",
    routingNumber: "Routing Number",
    accountHolderName: "Account Holder Name",
    authorizationToTransfer:
      "Authorization to Transfer to Cambridge Caregivers, LLC",
  };

  const creditCardDetailsLabels = {
    cardHolderName: "Card Holder Name",
    cardNumber: "Card Number",
    expirationDate: "Expiration Date",
    cvv: "CVV",
    zipCode: "Zip Code",
    feeAcknowledgment: "Credit Card Processing Fee Acknowledgment",
  };

  return (
    <>
      <Typography variant="h4" color="default.main">
        Payment Details
      </Typography>
      <Grid2 container spacing={3} mt={3}>
        {/* Loop over the top-level fields in paymentDetailsSection0 */}
        {Object.entries(paymentDetailsLabels).map(([key, label]) => {
          const value = formData?.paymentDetailsSection0?.[key];
          let formattedValue = "N/A";

          if (label && label === "Signature") {
            return (
              <>
                <Grid2 size={{ xs: 12, sm: 12 }}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    Payment Agreement
                  </Typography>
                  <Typography
                    variant="body1"
                    color="default.light"
                    dangerouslySetInnerHTML={{
                      __html: paymentTermsAndAgreement["description"],
                    }}
                  ></Typography>
                </Grid2>
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    Signature
                  </Typography>
                  <Typography variant="body1" color="default.light">
                    {(formData?.paymentDetailsSection0?.signatureInfo
                      ?.signature && (
                      <img
                        src={
                          formData?.paymentDetailsSection0?.signatureInfo
                            ?.signature
                        }
                        alt="Signature"
                        style={{ maxWidth: "100%", maxHeight: "200px" }}
                      />
                    )) ||
                      "No signature provided"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 6, sm: 6 }}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    Name of Signer
                  </Typography>
                  <Typography variant="body1" color="default.light">
                    {formData?.paymentDetailsSection0?.signatureInfo
                      ?.NameOfSigner || "-"}
                  </Typography>
                </Grid2>
              </>
            );
          }

          switch (label) {
            case "Base Rate (Per Hour)":
              formattedValue = value ? `$ ${value}` : "N/A";
              break;

            case "Do you plan to use Veterans Affairs (VA) benefits to pay for or support your care?":
              formattedValue =
                paymentDetailVeteransAffairsEnumMap[value] ?? "N/A";
              break;

            case "Payment Method":
              formattedValue = paymentMethodEnumMap[value] || "N/A";
              break;

            case "Service Type":
              formattedValue = paymentServiceEnumMap[value] || "N/A";
              break;
            default:
              formattedValue = value || "N/A";
              break;
          }

          return (
            <Grid2 size={{ xs: 12, sm: 6 }} key={key}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                {label}
              </Typography>

              <ExpandableTypography>{formattedValue}</ExpandableTypography>
            </Grid2>
          );
        })}
      </Grid2>
      {/* Conditionally Render Bank Details */}
      {formData?.paymentDetailsSection0?.paymentMethod === "bank" &&
        formData?.paymentDetailsSection0?.bankDetails && (
          <>
            <Typography variant="h4" mt={3} color="default.main">
              Bank Details
            </Typography>
            <Grid2 container spacing={3} mt={3} key="bankDetails">
              {Object.entries(bankDetailsLabels).map(([key, label]) => {
                const value =
                  formData?.paymentDetailsSection0?.bankDetails?.[key];

                return (
                  <Grid2 size={{ xs: 12, sm: 6 }} key={key}>
                    <Typography variant="body2" color="default.main" mb={0.5}>
                      {label}
                    </Typography>
                    {key === "authorizationToTransfer" && (
                      <Typography
                        variant="body2"
                        color="default.light"
                        mb={0.5}
                      >
                        {paymentTermsAndAgreement["bankTermsAndCondition"]}
                      </Typography>
                    )}
                    <Typography variant="body1" color="default.light">
                      {key === "authorizationToTransfer"
                        ? typeof value === "boolean" && value === true
                          ? "Yes, I agree to the Authorization to Transfer to Cambridge Caregivers, LLC"
                          : "No, I do not agree to the Authorization to Transfer to Cambridge Caregivers, LLC"
                        : value || "N/A"}
                    </Typography>
                  </Grid2>
                );
              })}
            </Grid2>
          </>
        )}

      {/* Conditionally Render Credit Card Details */}
      {formData?.paymentDetailsSection0?.paymentMethod === "credit" &&
        formData?.paymentDetailsSection0?.creditCardDetails && (
          <>
            <Typography variant="h4" mt={3} color="default.main">
              Credit Card Details
            </Typography>
            <Grid2 container spacing={3} mt={3} key="creditCardDetails">
              {Object.entries(creditCardDetailsLabels).map(([key, label]) => {
                const value =
                  formData?.paymentDetailsSection0?.creditCardDetails?.[key];

                return (
                  <Grid2 size={{ xs: 12, sm: 6 }} key={key}>
                    <Typography variant="body2" color="default.main" mb={0.5}>
                      {label}
                    </Typography>
                    {key === "feeAcknowledgment" && (
                      <Typography
                        variant="body2"
                        color="default.light"
                        mb={0.5}
                      >
                        {paymentTermsAndAgreement["creditTermsAndCondition"]}
                      </Typography>
                    )}
                    <Typography variant="body1" color="default.light">
                      {key === "feeAcknowledgment"
                        ? typeof value === "boolean" && value === true
                          ? "Yes, I agree to the Credit Card Processing Fee Acknowledgment"
                          : "No, I do not agree to the Credit Card Processing Fee Acknowledgment"
                        : value || "N/A"}
                    </Typography>
                  </Grid2>
                );
              })}
            </Grid2>
          </>
        )}
    </>
  );
};
export default PaymentDetail;
